import { render, staticRenderFns } from "./ServiceTypeUpdate.vue?vue&type=template&id=717fa29a&"
import script from "./ServiceTypeUpdate.vue?vue&type=script&lang=js&"
export * from "./ServiceTypeUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports